<app-header></app-header>
<br />
<app-error *ngIf="isError" [message]="errorMessage"></app-error>
<div class="container">
  <div class="panel panel-default">
    <div class="panel panel-body container-shadow">
      <div class="row mt-3">
        <div class="col-md-12">
          <h1 class="text-center" style="color: #777777;"><b>What do you want to do today?</b></h1>
        </div>
      </div>
      <div class="mt-5"><hr /></div>
      <div class="row mt-5">
        <div class="col-md-4">
          <a routerLink="/requests" style="text-decoration: none;" href="#">
            <div class="panel-home background-navy">
              <div class="p-5 text-center">
                <span class="text-home">View/Edit</span>
                <div class="clearfix"></div>
                <span class="text-home-heading">
                  my requests
                </span>
                <span class="text-home-heading font-color-white" *ngIf="activeRequestCount>-1"><span id="activeRequestsCountonIndex" class="text-home-heading font-color-white">({{activeRequestCount}})</span></span>
              </div>
            </div>
          </a>
        </div>
        <div class="col-md-4">
          <a routerLink="/tasks" style="text-decoration: none;" href="#">
            <div class="panel-home background-navy">
              <div class="p-5 text-center">
                <span class="text-home">View/Edit</span>
                <div class="clearfix"></div>
                <span class="text-home-heading">
                  my tasks
                </span>
                <span class="text-home-heading font-color-white" *ngIf="pendingTasksCount>-1"><span id="pendingRequestsCountonIndex" class="text-home-heading font-color-white">({{pendingTasksCount}})</span></span>
              </div>
            </div>
          </a>
        </div>
        <div class="col-md-4">
          <a routerLink="/allrequests" style="text-decoration: none;" href="#">
            <div class="panel-home background-navy">
              <div class="p-5 text-center">
                <span class="text-home">View</span>
                <div class="clearfix"></div>
                <span class="text-home-heading">
                  all requests
                </span>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div class="mt-5"><hr /></div>
      <div class="row mt-5">
        <div class="mx-auto col-md-4">
          <a routerLink="/create" style="text-decoration: none;">
            <div class="panel-home background-navy">
              <div class="p-5 text-center">
                <span class="text-home">Request a</span>
                <div class="clearfix"></div>
                <span class="text-home-heading">Review</span>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div class="mt-5"><hr /></div>
      <div class="row mt-5">
        <div class="col-md-12"><img alt="Eurofins" src="/assets/eurofins_blue.png" class="mx-auto d-block" /></div>
      </div>
    </div>
  </div>
</div>

